export default __webpack_public_path__ + "static/media/EquityRating.904f7ff3.svg";